import * as React from 'react';
import {FormGroupProps} from "../../../../components/common/props/FormGroupProps";
import {PlaceholderProps} from "../../../../components/common/props/PlaceholderProps";
import {DisableableProps} from "../../../../components/common/props/DisableableProps";
import {EditableProps} from "../../../../components/common/props/EditableProps";
import {FocusableProps} from "../../../../components/common/props/FocusableProps";
import {TrimableProps} from "../../../../components/common/props/TrimableProps";
import {none, option} from "ts-option";
import FormGroup from "./FormGroup";
import Input from "../../atoms/Input/Input";

type Props = EditableProps & FormGroupProps<string> & PlaceholderProps & DisableableProps & FocusableProps & TrimableProps

export default class InputFormGroup extends React.Component<Props, {}> {

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<Input type={"text"}
					   onChange={value => this.onChange(value)}
					   value={this.props.field.value.getOrElse("")}
					   placeholder={this.props.placeholder}
					   disabled={this.props.disabled}
					   readonly={this.props.readonly}
					   focus={this.props.focus}
					   onFocus={this.props.onFocus}/>
			</FormGroup>
		);
	}

	onChange(event: React.ChangeEvent<HTMLInputElement>) {
		const value = this.props.trimRight ? event.target.value.trimRight() : event.target.value;
		this.props.onChange(this.props.field.updateValue(value.length ? option(value) : none));
	}
}